import { KeyValue } from "@/main/models/common";
import { UserTypeTypes, UserTypeActionTypes } from "./userTypeTypes";

export function getUserType(): UserTypeActionTypes {
	return {
		type: UserTypeTypes.GET_USER_TYPE,
	};
}

export function saveUserType(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): UserTypeActionTypes {
	return {
		type: UserTypeTypes.SAVE_USER_TYPE,
		payload: { data, isError, errorMessages },
	};
}

export function getUserTypePublic(): UserTypeActionTypes {
	return {
		type: UserTypeTypes.GET_USER_TYPE_PUBLIC,
	};
}

export function saveUserTypePublic(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): UserTypeActionTypes {
	return {
		type: UserTypeTypes.SAVE_USER_TYPE_PUBLIC,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerUserType(): UserTypeActionTypes {
	return {
		type: UserTypeTypes.RESET_REDUCER_USER_TYPE,
	};
}
